import { Div, Base } from '@codesuma/baseline'
import font, { Font } from '../../../services/font'
import style from './index.module.css'

// The app-font picker, shown as a labeled settings row in the menu. Each option
// previews its own typeface; the choice is applied instantly and persisted by the
// font service.
export const FontRow = () => {
    const base = Div()
    base.addClass(style.base)

    const label = Div('Font')
    label.addClass(style.label)

    const select = Base('select') as any
    select.addClass(style.select)
    for (const f of font.FONTS) {
        const opt = document.createElement('option')
        opt.value = f
        opt.textContent = f
        opt.style.fontFamily = `"${f}"`
        select.el.appendChild(opt)
    }
    ;(select.el as HTMLSelectElement).value = font.get()
    select.el.addEventListener('change', () => {
        font.set((select.el as HTMLSelectElement).value as Font)
    })

    base.append(label, select)
    return base
}
